
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { ErrorBoundary } from "@/components/admin/ErrorBoundary";
import { Loader2 } from "lucide-react";

const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-screen">
    <Loader2 className="h-8 w-8 animate-spin" />
  </div>
);

const RootLayout: React.FC = () => {
  return (
    <React.Fragment>
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
      <Toaster />
    </React.Fragment>
  );
};

export default RootLayout;
